export const CBU_TO_BANK = {
  '007': 'BANCO DE GALICIA Y BUENOS AIRES S.A.U.',
  '011': 'BANCO DE LA NACIÓN ARGENTINA',
  '014': 'BANCO DE LA PROVINCIA DE BUENOS AIRES',
  '015': 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA',
  '016': 'CITIBANK N.A.',
  '017': 'BANCO BBVA ARGENTINA S.A.',
  '020': 'BANCO DE LA PROVINCIA DE CORDOBA S.A.',
  '027': 'BANCO SUPERVIELLE S.A.',
  '029': 'BANCO DE LA CIUDAD DE BUENOS AIRES',
  '034': 'BANCO PATAGONIA S.A.',
  '044': 'BANCO HIPOTECARIO S.A.',
  '045': 'BANCO DE SAN JUAN S.A.',
  '065': 'BANCO MUNICIPAL DE ROSARIO',
  '072': 'BANCO SANTANDER ARGENTINA S.A.',
  '083': 'BANCO DEL CHUBUT S.A.',
  '086': 'BANCO DE SANTA CRUZ S.A.',
  '093': 'BANCO DE LA PAMPA SOCIEDAD DE ECONOMÍA M',
  '094': 'BANCO DE CORRIENTES S.A.',
  '097': 'BANCO PROVINCIA DEL NEUQUÉN SOCIEDAD ANÓ',
  '131': 'BANK OF CHINA LIMITED SUCURSAL BUENOS AI',
  '143': 'BRUBANK S.A.U.',
  '147': 'BANCO INTERFINANZAS S.A.',
  '150': 'HSBC BANK ARGENTINA S.A.',
  '158': 'OPEN BANK ARGENTINA S.A.',
  '165': 'JPMORGAN CHASE BANK, NATIONAL ASSOCIATIO',
  '191': 'BANCO CREDICOOP COOPERATIVO LIMITADO',
  '198': 'BANCO DE VALORES S.A.',
  '247': 'BANCO ROELA S.A.',
  '254': 'BANCO MARIVA S.A.',
  '259': 'BANCO ITAU ARGENTINA S.A.',
  '266': 'BNP PARIBAS',
  '268': 'BANCO PROVINCIA DE TIERRA DEL FUEGO',
  '269': 'BANCO DE LA REPÚBLICA ORIENTAL DEL URUGU',
  '277': 'BANCO SAENZ S.A.',
  '281': 'BANCO MERIDIAN S.A.',
  '285': 'BANCO MACRO S.A.',
  '299': 'BANCO COMAFI SOCIEDAD ANONIMA',
  '300': 'BANCO DE INVERSION Y COMERCIO EXTERIOR S',
  '301': 'BANCO PIANO S.A.',
  '305': 'BANCO JULIO SOCIEDAD ANONIMA',
  '309': 'BANCO RIOJA SOCIEDAD ANONIMA UNIPERSONAL',
  '310': 'BANCO DEL SOL S.A.',
  '311': 'NUEVO BANCO DEL CHACO S. A.',
  '312': 'BANCO VOII S.A.',
  '315': 'BANCO DE FORMOSA S.A.',
  '319': 'BANCO CMF S.A.',
  '321': 'BANCO DE SANTIAGO DEL ESTERO S.A.',
  '322': 'BANCO INDUSTRIAL S.A.',
  '330': 'NUEVO BANCO DE SANTA FE SOCIEDAD ANONIMA',
  '331': 'BANCO CETELEM ARGENTINA S.A.',
  '332': 'BANCO DE SERVICIOS FINANCIEROS S.A.',
  '338': 'BANCO DE SERVICIOS Y TRANSACCIONES S.A.',
  '339': 'RCI BANQUE S.A.',
  '340': 'BACS BANCO DE CREDITO Y SECURITIZACION S',
  '341': 'BANCO MASVENTAS S.A.',
  '384': 'WILOBANK S.A.U.',
  '386': 'NUEVO BANCO DE ENTRE RÍOS S.A.',
  '389': 'BANCO COLUMBIA S.A.',
  '426': 'BANCO BICA S.A.',
  '431': 'BANCO COINAG S.A.',
  '432': 'BANCO DE COMERCIO S.A.',
  '435': 'BANCO SUCREDITO REGIONAL S.A.U.',
  '448': 'BANCO DINO S.A.',
};

export const CHECK_CBU = {
  COINAG: '00000536',
};
